import React, { useContext } from "react";

import { IntlContext } from "context";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/tooltip";
import { cn } from "lib/utils";

interface VerifiedProfileBadgeProps {
    size?: "sm" | "lg";
    labelKey?: "provider.card.verified_profile" | "ad.card.verified_profile";
    className?: string;
}

export const VerifiedProfileBadge: React.FC<VerifiedProfileBadgeProps> = ({
    size = "sm",
    labelKey = "provider.card.verified_profile",
    className,
}) => {
    const intl = useContext(IntlContext);
    const label = String(intl.formatMessage(labelKey));
    const width = size === "lg" ? 16 : 15;

    return (
        <TooltipProvider delayDuration={100}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        type="button"
                        className={cn(
                            "inline-flex shrink-0 border-0 bg-transparent p-0 align-middle",
                            className,
                        )}
                        aria-label={label}
                    >
                        <img src="/images/verifier.png" width={width} alt="" aria-hidden className="inline-block" />
                    </button>
                </TooltipTrigger>
                <TooltipContent side="top">{label}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
